<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <entegratorsecim ref="entegratorsecim" @callStop="EntegratorAyarlariKayitEdilmedi"  @callDevam="EntegratorAyarlariKayitEdildi" @callEntegratorVar="EntegratorVar"></entegratorsecim>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Komisyon Faturası Listesi</v-toolbar-title>
              <v-spacer></v-spacer>

            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <v-select :label="$t('Date-Type')" items-value="value" item-text="text" :items="itemstarihtip"
                          v-model="tarihTip"></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla" v-model="KayitTarihiBasla"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis" v-model="KayitTarihiBitis"></tarihcomp>
                      </v-flex>


                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getListcontrol()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                            </template>

                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>


                <v-flex xs12 pt-2 sm6 md6>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap class="pl-1 pr-1 project overdue">
                        <v-toolbar flat="" size="120px" dark color="white">
                          <v-toolbar-title> <span class="subheading black--text">
                              {{$t('Records')}}
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>
                            <v-flex xs12 sm4 md4 v-if="dizaynData.length!=0">
                               <v-layout justify-start>
                                 <v-btn flat @click="ItemAktarTumu(dizaynData,dizaynData2)" color="green">
                                   Tümünü Seç
                                   <v-icon color="green">
                                     double_arrow
                                   </v-icon>
                                 </v-btn>                                     
                              </v-layout>

                             </v-flex>
                        </v-toolbar>
                      </v-layout>
                    </v-flex>

                    <v-flex pt-2 xs12 sm12 md12>
                      <v-card flat>
                        <v-layout row wrap class="pa-3 project overdue">


                          <v-flex xs12 md12>
                            <v-layout row wrap>


                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">PNR</div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2 grey--text">Satıcı Tip</div>
                                </v-layout>

                              </v-flex>



                              <v-flex xs2 sm2 m2>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">Satıcı Kod</div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">{{$t('Currentcode_label')}}</div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text"> {{ $t('Process-Ref') }} </div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">Op. Kod</div>
                                </v-layout>

                              </v-flex>

                            </v-layout>
                          </v-flex>

                          <v-flex xs12 md12>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex v-for="element in dizaynData" :key="element.PNR_NO" xs12 md12>
                            <v-layout row wrap>


                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{element.PNR_No}}</div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm2 md2>
                                <v-layout row wrap>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-left>
                                      <div class="justify-center body-2 grey--text">{{element.SaticiTip}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs2 sm2 md2>
                                <v-layout row wrap>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-left>
                                      <div class="body-2 	 justify-center   grey--text">{{element.SaticiKod}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">{{element.CariKod}}</div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">{{element.IslemRef}}</div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">{{element.OperatorKod}}</div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <v-btn icon ripple>
                                    <v-icon @click="ItemAktar(dizaynData,dizaynData2,element)" color="green">
                                      arrow_forward_ios
                                    </v-icon>
                                  </v-btn>
                                </v-layout>

                              </v-flex>
                              <v-flex xs2 sm12 md12>
                                <v-divider></v-divider>
                              </v-flex>




                            </v-layout>
                          </v-flex>




                        </v-layout>

                      </v-card>


                    </v-flex>

                  </v-layout>



                </v-flex>


                <v-flex xs12 pt-2 sm6 md6>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap class="pl-1 pr-1 project complete">
                        <v-toolbar flat="" size="120px" dark color="white">
                          <v-toolbar-title> <span class="subheading black--text">
                              {{$t('Records-Selected')}}
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </v-layout>
                    </v-flex>


                    <v-flex pt-2 xs12 sm12 md12>
                      <v-card flat>
                        <v-layout row wrap class="pa-3 project complete">

                          <v-flex v-if="dizaynData2.length==0" xs12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{$t('No-Records')}}</div>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>





                          <v-flex v-if="dizaynData2.length>0" xs12 md12>
                            <v-layout row wrap>
                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text"></div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">PNR</div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2 grey--text">Satıcı Tip</div>
                                </v-layout>

                              </v-flex>



                              <v-flex xs2 sm2 m2>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">Satıcı Kod</div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">{{$t('Currentcode_label')}}</div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text"> {{ $t('Process-Ref') }} </div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">Op. Kod</div>
                                </v-layout>

                              </v-flex>

                            </v-layout>
                          </v-flex>

                          <v-flex xs12 v-if="dizaynData.length>0" md12>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex v-for="element in dizaynData2" :key="element.PNR_NO" xs12 md12>
                            <v-layout row wrap>

                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <v-btn icon ripple>
                                    <v-icon @click="ItemAktar(dizaynData2,dizaynData,element)" color="red">
                                      arrow_back_ios
                                    </v-icon>
                                  </v-btn>
                                </v-layout>

                              </v-flex>


                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{element.PNR_No}}</div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm2 md2>
                                <v-layout row wrap>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-left>
                                      <div class="justify-center body-2 grey--text">{{element.SaticiTip}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs2 sm2 md2>
                                <v-layout row wrap>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-left>
                                      <div class="body-2 	 justify-center   grey--text">{{element.SaticiKod}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">{{element.CariKod}}</div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">{{element.IslemRef}}</div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs12 sm2 md2>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">{{element.OperatorKod}}</div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs2 sm12 md12>
                                <v-divider></v-divider>
                              </v-flex>




                            </v-layout>
                          </v-flex>
                          <v-flex xs12 v-if="dizaynData2.length>0" md12>
                            <v-btn flat @click="faturala()" color="green" block> {{ $t('Invoice-Selected-Records') }} </v-btn>

                          </v-flex>



                        </v-layout>

                      </v-card>


                    </v-flex>

                  </v-layout>



                </v-flex>


              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="Rapor.PPNR_No" hide-details>
                              </pnrbul>
                            </v-flex>
                            <v-flex md12 xs12 sm12>
                             <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="Rapor.CariKod" v-model="Rapor.CariKod" :Coper="true"></cariaracomp>

                            </v-flex>
                            <v-flex md6 xs12 sm6>
                              <v-select clearable :items="itemssaticitip" item-text="Aciklama" item-value="Kod"
                                v-model="Rapor.SaticiTip" :label="$t('Seller-Type')" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama :autofocuss="true" apiname="SaticiAra" :tip="Rapor.SaticiTip"
                                :label="$t('Seller-Code')" v-model="Rapor.SaticiKod"></genelarama>
                            </v-flex>

                            <v-flex pl-1 xs12 sm12 md12>
                              <genelarama apiname="MasrafMerkeziAra" :label="$t('Expense-Center-v2')"
                                v-model="Rapor.MasrafMerkezi"></genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <genelarama apiname="SaticiAra" :tip="12" :label="$t('Tour-Operator')"
                                v-model="Rapor.OperatorKod">
                              </genelarama>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox small v-model="Rapor.FaturalamayaHazir" :label="$t('Ready-for-Invoice')"
                                hide-details color="green">
                              </v-checkbox>

                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../../api/auth";
  import tarihcomp from "../../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../../coper/tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import rez from "../rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import draggable from "vuedraggable";
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import entegratorsecim from "@/components/app/customcomp/entegratorsecim.vue";


  export default {
    data() {
      return {

        dizaynData2: [],
        dizaynData: [],
        itemssaticitip: rez.SaticiTip,
        itemsicdis: rez.IcDis,
        itemsopsiyon: rez.Opsiyon,
        itemstarihtip: [{
            text: this.$t('Registration-Date'),
            value: 0
          }, {
            text: this.$t('Check-in-Date'),
            value: 1
          }, {
            text: this.$t('Check-out-Date'),
            value: 2
          }
          // , {
          //   text: 'Satis Fatura Tarihi',
          //   value: 3
          // }, {
          //   text: 'Komisyon Fatura Tarihi',
          //   value: 4
          // }, {
          //   text: 'Gelen Fatura Tarihi',
          //   value: 5
          // },
        ],

        itemskomisyon: [{
          text: this.$t('None'),
          value: false
        }, {
          text: this.$t('Available'),
          value: true
        }, {
          text: this.$t('All-v2'),
          value: null
        }],
        tarihTip: 0,

        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0
        },
        filtrevarmi: false,
        search: "",
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,


        headerssatis: [{
            text: "PNR",
            value: "PNR_No",
            width: "5%",
            align: "left"
          },
          {
            text: "Tarih",
            value: "Kayit Tarihi",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Currentcode_label'),
            value: "PNR_CariKod",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Sales'),
            value: "SatisTutar",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Buying'),
            value: "AlisTutar",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Commission'),
            value: "PKomisyonTutar",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Payment'),
            value: "Odeme",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Balance'),
            value: "Bakiye",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Commission'),
            value: "KomisyonTL",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Profit'),
            value: "PNR_Kar",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Title_label'),
            value: "CariUnvan",
            width: "10%",
            align: "left"
          },
          {
            text: "Sirket No",
            value: "SirketNo",
            width: "10%",
            align: "left"
          },
          {
            text: "Satış TL",
            value: "PNR_SatisTL",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Buying') + " TL",
            value: "PNR_AlisTL",
            width: "10%",
            align: "left"
          },
          {
            text: "Komisyon TL",
            value: "PNR_KomisyonTL",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('First-Entry'),
            value: "Donem1",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Last-Departure'),
            value: "Donem2",
            width: "10%",
            align: "left"
          },
          {
            text: "Kar TL",
            value: "PNR_KarTL",
            width: "10%",
            align: "left"
          },
          {
            text: "Satıcı Ad",
            value: "SaticiCariUnvan",
            width: "10%",
            align: "left"
          },
          {
            text: "Rez Yapan",
            value: "RezYapan",
            width: "10%",
            align: "left"
          },
          {
            text: "İsim",
            value: "KisiIsimList",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Main-Type'),
            value: "AnaTip",
            width: "10%",
            align: "left"
          },
          {
            text: "Acente",
            value: "Acente",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Country_label'),
            value: "PNRUlke",
            width: "10%",
            align: "left"
          }
        ],

        Rapor: {

          SirketNo: null,
          PNR_No: null,
          Kayit_Tarihi1: null,
          Kayit_Tarihi2: null,
          Giris_Tarihi1: null,
          Giris_Tarihi2: null,
          Cikis_Tarihi1: null,
          Cikis_Tarihi2: null,
          SaticiTip: null,
          SaticiKod: null,
          CariKod: null,
          OperatorKod: null,
          MasrafMerkezi: null,
          FaturalamayaHazir: null,
          EFatura: null,


          // PSirketNo: null, //eklendi

          // PPNR_No: null, //eklendi
          // PPNR_ParaBirimi: "TL", //eklendi
          // PKayitTarihBas: null, //eklendi
          // PKayitTarihBit: null, //eklendi
          // PDonem1Bas: null, //eklendi
          // PDonem1Bit: null, //eklendi
          // PDonem2Bas: null, //eklendi
          // PDonem2Bit: null, //eklendi
          // PFatTarihBas: null, //eklendi
          // PFatTarihBit: null, //eklendi
          // PKomFatTarihBas: null, //eklendi
          // PKomFatTarihBit: null, //eklendi
          // PCariKod: null, //eklendi
          // PSaticiTip: 1, //eklendi
          // PSaticiKod: null, //eklendi
          // PDosyaTip: null,
          // PDosya: null,
          // PAcente: null,
          // PPNRBir: null,
          // PCariHesapGrubu: null, //eklendi
          // PCariTip: null,
          // PSaticiGrup: null, //eklendi
          // PSaticiIc_Dis: null, //eklendi
          // PTurOp: null, //eklendi
          // PFaturali: null,
          // POpsiyon: null, //eklendi
          // PAnaTip: null, //eklendi
          // PCariAnaHesap: null, //eklendi
          // PIptalRaporu: null,
          // PRezGrupID: null,
          // PSatisGrubu: null,
          // PSatisGrupTip: null,
          // PSaticiOdemesiHesapla: null,
          // PMasrafMerkezi: null, //eklendi
          // PAcenteDepartmanID: null,
          // PPozisyonNo: null,
          // PSatisFaturaNo: null,
          // PMusteriOdemelilerHaric: null,
          // PReferans: null, //eklendi
          // PSatisTip1: null,
          // PSatisTip2: null,
          // PSatisTip3: null,
          // PSatisTip4: null,
          // PGelenFatTarihBas: null, //eklen
          // PGelenFatTarihBit: null, //eklendi
          // PProfilSablonId: null,
          // PKomisyonFaturali: null,
          // PGelenFaturali: null,
        },

        KayitTarihiBasla: null,
        KayitTarihiBitis: null,
        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        tumsirketler: "",
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: "",
        date2: null,
        menu2: false,
        dateFormatted2: "",
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",

        renk1: "info",
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: "",
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemsiade: [],
        itemsvoid: [],

        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-choose-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-choose-a-date')
            }
          }
        }
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize("en", this.dictionary);
      this.el = this.$refs.fab.$el;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        })
        .then(
          response => {
            this.doviztipi = response.body;
          },
          response => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );

      // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      // if (this.sayfayetki.Status == true) {

      // } else {

      //   this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

      //     if (sonuc == true) {

      //       if (this.prevRoute != null) {
      //         var url = '#' + this.prevRoute

      //         window.open(url, '_self')
      //       } else {
      //         var url = '#/'
      //         window.open(url, '_self')
      //       }
      //     } else {

      //     }

      //   });

      // }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      anatip,
      genelarama,
      referansmerkezicomp,
      pnrbul,
      draggable,
      cariaracomp,
      entegratorsecim
    },
    watch: {},
    methods: {
      getListcontrol()
    {
      this.$refs.entegratorsecim.control();
    },
    EntegratorAyarlariKayitEdildi() {
     
     this.$refs.entegratorsecim.close();

     this.getList();
   },
   EntegratorVar()
   {
    this.getList();
   },
 
   EntegratorAyarlariKayitEdilmedi() {
     alert("Entegrator Ayarları Kayıt Edilmedi");
     this.$refs.entegratorsecim.close();
   },
        ItemAktarTumu(kaynak, hedef) {
        kaynak.forEach(element => {
         hedef.push(element);
        });
        kaynak.splice(0, kaynak.length)
      },
      faturala() {

        var degerler = []



        this.dizaynData2.forEach(element => {

        });

        this.dizaynData2.forEach(element => {
          degerler.push(element.IslemRef)
        });

        window.localStorage.setItem('container', JSON.stringify(degerler));
        var url = '#/coper/komisyonfaturasi/faturaislem'
        window.open(url, '_target')
      },
      ItemAktar(kaynak, hedef, item) {

        var n = kaynak.indexOf(item);
        hedef.push(item);
        kaynak.splice(n, 1);

      },
      onMove({
        relatedContext,
        draggedContext
      }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return ((!relatedElement || !relatedElement.fixed) && !draggedElement.fixed);

      },
      HataYonetimi(response, request, baslik) {
        if (response.status === 500) {
          //Internal Server Error
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = "Service Unavailable -" + baslik;
          this.snackbar = true;
        }
      },

      git(val) {
        var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
        window.open(url, "_target");
      },
      getList: getList,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },
    computed: {

      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: !this.editable,
          ghostClass: "ghost"
        };
      }
    },
  };

  function filtrele() {
    this.dialogfiltre = true;
  }

  function filtrekayit() {
    this.filtrevarmi = true;
    this.dialogfiltre = false;
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false;
    this.dialogfiltre = false;


    this.Rapor.PPNR_No = null
    this.Rapor.PPNR_ParaBirimi = 'TL'
    this.Rapor.PCariKod = null
    this.Rapor.PSaticiTip = null
    this.Rapor.PSaticiKod = null
    this.Rapor.PDosyaTip = null
    this.Rapor.PDosya = null
    this.Rapor.PAcente = null
    this.Rapor.PPNRBir = null
    this.Rapor.PCariHesapGrubu = null
    this.Rapor.PCariTip = null
    this.Rapor.PSaticiGrup = null
    this.Rapor.PSaticiIc_Dis = null
    this.Rapor.PTurOp = null
    this.Rapor.PFaturali = null
    this.Rapor.POpsiyon = null
    this.Rapor.PAnaTip = null
    this.Rapor.PCariAnaHesap = null
    this.Rapor.PIptalRaporu = null
    this.Rapor.PRezGrupID = null
    this.Rapor.PSatisGrubu = null
    this.Rapor.PSatisGrupTip = null
    this.Rapor.PSaticiOdemesiHesapla = null
    this.Rapor.PMasrafMerkezi = null
    this.Rapor.PAcenteDepartmanID = null
    this.Rapor.PPozisyonNo = null
    this.Rapor.PSatisFaturaNo = null
    this.Rapor.PMusteriOdemelilerHaric = null
    this.Rapor.PReferans = null
    this.Rapor.PSatisTip1 = null
    this.Rapor.PSatisTip2 = null
    this.Rapor.PSatisTip3 = null
    this.Rapor.PSatisTip4 = null
    this.Rapor.PProfilSablonId = null
    this.Rapor.PKomisyonFaturali = null
    this.Rapor.PGelenFaturali = null

  }

  function getList() {
    if (this.$refs.formgunluksatis.validate()) {

      this.dizaynData2=[];
      this.dizaynData=[];
      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);

      if (this.tarihTip == 0) {

        this.Rapor.Kayit_Tarihi1 = this.KayitTarihiBasla
        this.Rapor.Kayit_Tarihi2 = this.KayitTarihiBitis

        this.Rapor.Giris_Tarihi1 = null
        this.Rapor.Giris_Tarihi2 = null

        this.Rapor.Cikis_Tarihi1 = null
        this.Rapor.Cikis_Tarihi2 = null

        // this.Rapor.PFatTarihBas = null
        // this.Rapor.PFatTarihBit = null

        // this.Rapor.PKomFatTarihBas = null
        // this.Rapor.PKomFatTarihBit = null

        // this.Rapor.PGelenFatTarihBas = null
        // this.Rapor.PGelenFatTarihBit = null


      } else if (this.tarihTip == 1) {


        this.Rapor.Kayit_Tarihi1 = null
        this.Rapor.Kayit_Tarihi2 = null

        this.Rapor.Giris_Tarihi1 = this.KayitTarihiBasla
        this.Rapor.Giris_Tarihi2 = this.KayitTarihiBitis

        this.Rapor.Cikis_Tarihi1 = null
        this.Rapor.Cikis_Tarihi2 = null

        // this.Rapor.PFatTarihBas = null
        // this.Rapor.PFatTarihBit = null

        // this.Rapor.PKomFatTarihBas = null
        // this.Rapor.PKomFatTarihBit = null

        // this.Rapor.PGelenFatTarihBas = null
        // this.Rapor.PGelenFatTarihBit = null


      } else if (this.tarihTip == 2) {


        this.Rapor.Kayit_Tarihi1 = null
        this.Rapor.Kayit_Tarihi2 = null

        this.Rapor.Giris_Tarihi1 = null
        this.Rapor.Giris_Tarihi2 = null

        this.Rapor.Cikis_Tarihi1 = this.KayitTarihiBasla
        this.Rapor.Cikis_Tarihi2 = this.KayitTarihiBitis

        // this.Rapor.PFatTarihBas = null
        // this.Rapor.PFatTarihBit = null

        // this.Rapor.PKomFatTarihBas = null
        // this.Rapor.PKomFatTarihBit = null

        // this.Rapor.PGelenFatTarihBas = null
        // this.Rapor.PGelenFatTarihBit = null


      } else if (this.tarihTip == 3) {

        this.Rapor.PKayitTarihBas = null
        this.Rapor.PKayitTarihBit = null

        this.Rapor.PDonem1Bas = null
        this.Rapor.PDonem1Bit = null

        this.Rapor.PDonem2Bas = null
        this.Rapor.PDonem2Bit = null

        // this.Rapor.PFatTarihBas = this.KayitTarihiBasla
        // this.Rapor.PFatTarihBit = this.KayitTarihiBitis

        // this.Rapor.PKomFatTarihBas = null
        // this.Rapor.PKomFatTarihBit = null

        // this.Rapor.PGelenFatTarihBas = null
        // this.Rapor.PGelenFatTarihBit = null

      } else if (this.tarihTip == 4) {

        this.Rapor.PKayitTarihBas = null
        this.Rapor.PKayitTarihBit = null

        this.Rapor.PDonem1Bas = null
        this.Rapor.PDonem1Bit = null

        this.Rapor.PDonem2Bas = null
        this.Rapor.PDonem2Bit = null

        this.Rapor.PFatTarihBas = null
        this.Rapor.PFatTarihBit = null

        this.Rapor.PKomFatTarihBas = this.KayitTarihiBasla
        this.Rapor.PKomFatTarihBit = this.KayitTarihiBitis

        this.Rapor.PGelenFatTarihBas = null
        this.Rapor.PGelenFatTarihBit = null

      } else if (this.tarihTip == 5) {

        this.Rapor.PKayitTarihBas = null
        this.Rapor.PKayitTarihBit = null

        this.Rapor.PDonem1Bas = null
        this.Rapor.PDonem1Bit = null

        this.Rapor.PDonem2Bas = null
        this.Rapor.PDonem2Bit = null

        this.Rapor.PFatTarihBas = null
        this.Rapor.PFatTarihBit = null

        this.Rapor.PKomFatTarihBas = null
        this.Rapor.PKomFatTarihBit = null

        this.Rapor.PGelenFatTarihBas = this.KayitTarihiBasla
        this.Rapor.PGelenFatTarihBit = this.KayitTarihiBitis

      }
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));



      if (bastarih <= bittarih) {
        this.progress = true;
        this.load1 = false;

        this.Rapor.SirketNo = credentials.CoperSirketNo
        // this.Rapor.PCariSirket = credentials.SirketKodu

        var RaporParam = {}




        RaporParam.SirketNo = this.Rapor.SirketNo
        RaporParam.PNR_No = this.Rapor.PNR_No
        //RaporParam.PPNR_ParaBirimi = this.Rapor.PPNR_ParaBirimi
        RaporParam.Kayit_Tarihi1 = this.Rapor.Kayit_Tarihi1
        RaporParam.Kayit_Tarihi2 = this.Rapor.Kayit_Tarihi2
        RaporParam.Giris_Tarihi1 = this.Rapor.Giris_Tarihi1
        RaporParam.Giris_Tarihi = this.Rapor.Giris_Tarihi2
        RaporParam.Cikis_Tarihi1 = this.Rapor.Cikis_Tarihi1
        RaporParam.Cikis_Tarihi2 = this.Rapor.Cikis_Tarihi2
        // RaporParam.PFatTarihBas = this.Rapor.PFatTarihBas
        //  RaporParam.PFatTarihBit = this.Rapor.PFatTarihBit
        //  RaporParam.PKomFatTarihBas = this.Rapor.PKomFatTarihBas
        //   RaporParam.PKomFatTarihBit = this.Rapor.PKomFatTarihBit

        if (this.Rapor.CariKod != null) {
          RaporParam.Cari_Kod = this.Rapor.CariKod.id
        } else {
          RaporParam.Cari_Kod = this.Rapor.CariKod
        }


        RaporParam.SaticiTip = this.Rapor.SaticiTip


        if (this.Rapor.SaticiKod != null) {
          RaporParam.SaticiKod = this.Rapor.SaticiKod.kod
        } else {
          RaporParam.SaticiKod = this.Rapor.SaticiKod
        }


        // RaporParam.PDosyaTip = this.Rapor.PDosyaTip
        //  RaporParam.PDosya = this.Rapor.PDosya
        //   RaporParam.Acente = this.Rapor.PAcente
        //   RaporParam.PPNRBir = this.Rapor.PPNRBir
        //   RaporParam.PCariHesapGrubu = this.Rapor.PCariHesapGrubu
        //   RaporParam.PCariTip = this.Rapor.PCariTip
        //   RaporParam.PSaticiGrup = this.Rapor.PSaticiGrup
        //   RaporParam.PSaticiIc_Dis = this.Rapor.PSaticiIc_Dis
        if (this.Rapor.OperatorKod != null) {
          RaporParam.OperatorKod = this.Rapor.OperatorKod.kod
        } else {
          RaporParam.OperatorKod = this.Rapor.OperatorKod
        }




        RaporParam.FaturalamayaHazir = this.Rapor.FaturalamayaHazir
        //   RaporParam.POpsiyon = this.Rapor.POpsiyon
        //    RaporParam.PAnaTip = this.Rapor.PAnaTip
        //    if (this.Rapor.PCariAnaHesap != null) {
        //      RaporParam.PCariAnaHesap = this.Rapor.PCariAnaHesap.id
        //    } else {
        //      RaporParam.PCariAnaHesap = this.Rapor.PCariAnaHesap
        // }



        //    RaporParam.PIptalRaporu = this.Rapor.PIptalRaporu
        //    RaporParam.PRezGrupID = this.Rapor.PRezGrupID
        //    RaporParam.PSatisGrubu = this.Rapor.PSatisGrubu
        //    RaporParam.PSatisGrupTip = this.Rapor.PSatisGrupTip
        //    RaporParam.PSaticiOdemesiHesapla = this.Rapor.PSaticiOdemesiHesapla

        if (this.Rapor.MasrafMerkezi != null) {
          RaporParam.MasrafMerkezi = this.Rapor.MasrafMerkezi.kod
        } else {
          RaporParam.MasrafMerkezi = this.Rapor.MasrafMerkezi
        }



        //   RaporParam.PAcenteDepartmanID = this.Rapor.PAcenteDepartmanID
        //  RaporParam.PPozisyonNo = this.Rapor.PPozisyonNo
        // RaporParam.PSatisFaturaNo = this.Rapor.PSatisFaturaNo
        // RaporParam.PMusteriOdemelilerHaric = this.Rapor.PMusteriOdemelilerHaric
        // RaporParam.PReferans = this.Rapor.PReferans
        // RaporParam.PSatisTip1 = this.Rapor.PSatisTip1
        // RaporParam.PSatisTip2 = this.Rapor.PSatisTip2
        // RaporParam.PSatisTip3 = this.Rapor.PSatisTip3
        // RaporParam.PSatisTip4 = this.Rapor.PSatisTip4
        // RaporParam.PGelenFatTarihBas = this.Rapor.PGelenFatTarihBas
        // RaporParam.PGelenFatTarihBit = this.Rapor.PGelenFatTarihBit
        // RaporParam.PProfilSablonId = this.Rapor.PProfilSablonId
        // RaporParam.PKomisyonFaturali = this.Rapor.PKomisyonFaturali
        // RaporParam.PGelenFaturali = this.Rapor.PGelenFaturali



        var params = {
          Value: RaporParam
        }



        tool.http_post(this, "KesileceKomisyonFaturaList", params).then(
          response => {
            if (response.body.Status == true) {
              this.itemssatis = response.body.data;
              this.dizaynData = this.itemssatis
              this.progress = false;
              this.load1 = true;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.progress = false;
              this.load1 = true;
            }
          },
          response => {
            this.HataYonetimi(response, params, 'Komisyon Farura Listesi Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  }

  function beforeMount() {}
</script>
<style>
  .project.complete {
    border-left: 4px solid green;
  }

  .project.ongoing {
    border-left: 4px solid orange;
  }

  .project.overdue {
    border-left: 4px solid red;
  }
</style>